import { Box, Paper, Typography } from '@mui/material';
import { BarChart, Bar, XAxis, YAxis, CartesianGrid, Tooltip, ResponsiveContainer, Cell } from 'recharts';

export type UserTypeTicketDatum = {
  name: string;
  value: number;
  color: string;
};

function UserTypeTicketCustomTooltip({
  active,
  payload,
}: {
  active?: boolean;
  payload?: Array<{ name: string; value?: number; payload?: UserTypeTicketDatum }>;
}) {
  if (!active || !payload?.length) return null;
  const entry = payload[0];
  const value = entry?.value ?? 0;
  const label = entry?.payload?.name ?? entry?.name ?? '티켓 발급 수';
  return (
    <Paper
      elevation={8}
      sx={{
        p: 1.5,
        minWidth: 140,
        borderRadius: 2,
        border: '1px solid',
        borderColor: 'divider',
      }}
    >
      <Typography variant="body2" color="text.secondary" sx={{ mb: 0.75, fontWeight: 600 }}>
        {label}
      </Typography>
      <Typography variant="body2" sx={{ display: 'flex', justifyContent: 'space-between', gap: 2 }}>
        <span style={{ color: '#666' }}>티켓 발급 수</span>
        <span style={{ fontWeight: 600 }}>{Number(value).toLocaleString('ko-KR')}</span>
      </Typography>
    </Paper>
  );
}

const TEMP_DATA: UserTypeTicketDatum[] = [
  { name: '기존 사용자', value: 10000, color: '#1E88E5' },
  { name: '신규 사용자', value: 5000, color: '#FF9800' },
];

type Props = {
  data?: UserTypeTicketDatum[];
};

export default function RouletteRevenueUserTypeTicketChart({ data = TEMP_DATA }: Props) {
  return (
    <Box
      sx={{
        width: '100%',
        minWidth: 440,
        minHeight: 300,
        backgroundColor: '#f8fafc',
        border: '1px solid #e2e8f0',
        borderRadius: 3,
        p: 2,
        display: 'flex',
        flexDirection: 'column',
      }}
    >
      <Typography variant="body2" fontWeight={600} sx={{ mb: 1, fontSize: '0.95rem' }} color="#424242">
        사용자 유형별 티켓 발급 수
      </Typography>
      <Box sx={{ flex: 1, minHeight: 200, display: 'flex', justifyContent: 'center', alignItems: 'center', mt: 0.5 }}>
        <ResponsiveContainer width="75%" height={200}>
        <BarChart
          layout="vertical"
          data={data}
          margin={{ top: 12, right: 64, left: 12, bottom: 12 }}
        >
          <CartesianGrid strokeDasharray="3 3" stroke="#e0e0e0" horizontal={false} />
          <XAxis type="number" hide />
          <YAxis type="category" dataKey="name" width={80} tick={{ fontSize: 13 }} axisLine={false} tickLine={false} />
          <Tooltip cursor={false} content={<UserTypeTicketCustomTooltip />} />
          <Bar dataKey="value" radius={[0, 4, 4, 0]} maxBarSize={36} label={{ position: 'right', formatter: (v: number) => v.toLocaleString('ko-KR'), fontSize: 13 }}>
            {data.map((entry, index) => (
              <Cell key={index} fill={entry.color} />
            ))}
          </Bar>
        </BarChart>
        </ResponsiveContainer>
      </Box>
    </Box>
  );
}
